import { authenticatedUser } from '../authentication/authModule';

export function processAzureUrl(url: string): string {

    // Validate if url is full with domian
    if (!url.includes('portal.azure.cn')) {
        console.error('URL is not Azure CN url, returning original', url);
        return url;
    }

    const tenantId = '62d11549-4655-4f82-9472-c5c46ff13f3b';
    const isXomServices = authenticatedUser.userEmail.toLowerCase().endsWith('xomservices.com');
    // Check if add tenant id is needed
    if (!isXomServices) {
        return url;
    }

    return url.replace('portal.azure.cn/', `portal.azure.cn/${tenantId}/`);
    
}

export function OpenAzureCN(url: string, target: string = '_blank', features?: string): void {
    const processedUrl = processAzureUrl(url);
    window.open(processedUrl, target, features);
}